import { ListItem, UnorderedList } from '@src/components/List'
import { getLoggedIn, getPaidMember } from '@src/state/auth/selectors'
import { copyText, downloadPaper, saveDocument } from '@src/state/document/actions'
import { selectForMinTextLength } from '@src/state/document/selectors'
import { handleFreeTrialStart as freeTrialStart } from '@src/state/payment/actions'
import { getHelpUrl } from '@src/state/site/selectors'
import site from '@src/state/site/site'
import { RootState } from '@src/state/types'
import { hardRedirect } from '@src/state/workspace/actions'
import { PHONE } from '@src/styled/media'
import {
  COPY_BUTTON,
  DOWNLOAD_BUTTON,
  HELP_BUTTON,
  MORE_ACTIONS_UPGRADE,
  MY_PAPERS_BUTTON,
  SAVE_BUTTON,
} from '@src/utils/dataTestIds'
import { push } from 'connected-react-router'
import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import RecheckMenuitems from '../Recheck/RecheckMenuitems'
import { MenuItem, TabList } from '../styles'
import LocaleSwitcher from './LocaleSwitcher'
import { CopyMenuItem, DownloadMenuItem, Upgrade } from './styles'
import * as Types from './types'

export const MORE_ACTIONS_MENU_CREATE_ACCOUNT = 'Create Account'
export const MORE_ACTIONS_MENU_SAVE = 'Save'
export const UPGRADE_TO_RECHECK = 'Upgrade to unlock this feature!'
export const COPY_TEXT = 'Copy'
export const DOWNLOAD_TEXT = 'Download'
export const Menu: React.FunctionComponent<Types.ComponentProps> = ({
  loggedIn,
  handleFreeTrialStart,
  linkToMyPapers,
  handleSave,
  media,
  copy,
  download,
  paidMember,
  hasMinText,
  redirectToHelp,
  checksRunning,
}) => {
  const freeTrialStartSave = () => handleFreeTrialStart(MORE_ACTIONS_MENU_SAVE)
  const freeTrialStartCreateAccount = () =>
    handleFreeTrialStart(MORE_ACTIONS_MENU_CREATE_ACCOUNT)
  return (
    <TabList>
      <UnorderedList>
        {media === PHONE && (
          <React.Fragment>
            {paidMember ? (
              <RecheckMenuitems hasMinText={hasMinText} checksRunning={checksRunning} />
            ) : (
              <ListItem>
                <Upgrade
                  data-test={MORE_ACTIONS_UPGRADE}
                  onClick={freeTrialStartCreateAccount}
                >
                  {UPGRADE_TO_RECHECK}
                </Upgrade>
              </ListItem>
            )}
            <ListItem>
              <CopyMenuItem
                data-test={COPY_BUTTON}
                onClick={copy}
                disabled={checksRunning}
              >
                {COPY_TEXT}
              </CopyMenuItem>
            </ListItem>

            <ListItem>
              <DownloadMenuItem
                data-test={DOWNLOAD_BUTTON}
                onClick={download}
                disabled={checksRunning}
              >
                {DOWNLOAD_TEXT}
              </DownloadMenuItem>
            </ListItem>
          </React.Fragment>
        )}

        <ListItem>
          <MenuItem
            onClick={loggedIn ? handleSave : freeTrialStartSave}
            data-test={SAVE_BUTTON}
            disabled={checksRunning}
          >
            Save
          </MenuItem>
        </ListItem>

        <ListItem>
          <MenuItem
            onClick={loggedIn ? linkToMyPapers : freeTrialStartCreateAccount}
            data-test={MY_PAPERS_BUTTON}
            disabled={checksRunning}
          >
            {loggedIn ? 'My papers' : 'Create Account'}
          </MenuItem>
        </ListItem>
        <ListItem>
          <LocaleSwitcher checksRunning={checksRunning} />
        </ListItem>
        <ListItem>
          <MenuItem
            onClick={redirectToHelp}
            data-test={HELP_BUTTON}
            disabled={checksRunning}
          >
            Help
          </MenuItem>
        </ListItem>
      </UnorderedList>
    </TabList>
  )
}

const mapStateToProps = (state: RootState) => ({
  loggedIn: getLoggedIn(state),
  paidMember: getPaidMember(state),
  hasMinText: selectForMinTextLength(state),
  checksRunning: state.workspace.checksRunning,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  handleFreeTrialStart: (origin: string) => dispatch(freeTrialStart(origin)),
  linkToMyPapers: () =>
    dispatch(
      push({
        pathname: '/',
        state: {
          helperText: 'My papers',
        },
      })
    ),
  handleSave: () => dispatch(saveDocument.request({ manual: true })),
  copy: () => dispatch(copyText()),
  download: () => dispatch(downloadPaper()),
  redirectToHelp: () =>
    dispatch(hardRedirect({ url: getHelpUrl(site) }, { label: 'Help' })),
})

export default connect<Types.StateMappedToProps, Types.DispatchMappedToProps>(
  mapStateToProps,
  mapDispatchToProps
)(Menu)



// WEBPACK FOOTER //
// ./src/layouts/shared/MoreActions/Menu.tsx